module.exports = __webpack_public_path__ + "logo_login.ce9af5d727f030062279.png";


//////////////////
// WEBPACK FOOTER
// /app/src/img/logo_login.png
// module id = ../../../../../src/img/logo_login.png
// module chunks = styles